import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { ChartCard, DonutChart } from "@/components/Elements/Charts";
import ListStatisticsCardExtra from "@/components/ListStatistics/ListStatisticsCardExtra";
import {
  useListStatistics,
  useListDonutChartSelected,
} from "@/components/ListStatistics/ListStatisticsHooks";
import { useAssetRisksReferential } from "@/modules/asset/asset-risk";
import { useTranslateNumber } from "@/modules/translate";

const STATS_DATA_KEY = "risk_levels";
const FILTER_KEY = "risk_level";

const AssetsRiskLevelDonutChart = () => {
  const { t } = useTranslation();
  const { translateNumber } = useTranslateNumber();
  const { riskLevels, getRiskLevel } = useAssetRisksReferential();

  const { loading, fetching, statsData } = useListStatistics({
    statsDataKey: STATS_DATA_KEY,
    filterKey: FILTER_KEY,
  });

  const chartData = useMemo(() => {
    return riskLevels.map(({ value, color }) => ({
      name: `${value}`,
      value: statsData[`${value}`] ?? 0,
      color,
    }));
  }, [riskLevels, statsData]);

  const { selectedLegend, onLegendSelectChange } = useListDonutChartSelected({
    filterKey: FILTER_KEY,
    chartData,
  });

  return (
    <ChartCard
      title={t("asset:statistics.riskLevel.title")}
      extra={<ListStatisticsCardExtra filterKey={FILTER_KEY} />}
    >
      <DonutChart
        data={chartData}
        loading={loading}
        fetching={fetching}
        controlled={{ selectedLegend }}
        onLegendSelectChange={onLegendSelectChange}
        formatName={(value) => getRiskLevel(value)?.name}
        formatTooltipValue={translateNumber}
      />
    </ChartCard>
  );
};

export default AssetsRiskLevelDonutChart;
